export var Browser;
(function (Browser) {
    Browser["Safari"] = "safari";
    Browser["Firefox"] = "firefox";
    Browser["Chrome"] = "chrome";
    Browser["Opera"] = "opera";
    Browser["Edge"] = "edge";
    Browser["Other"] = "other";
})(Browser || (Browser = {}));
//# sourceMappingURL=Browser.js.map